// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1fHt3","Footer":"Header_Footer__2J3wK"};